import { useState } from 'react';
import { KanbanPedidos } from './KanbanPedidos';
import { Pedidos as ListaPedidos } from './Pedidos';
import { LayoutGrid, List, Truck, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import api from '@/lib/api';
import { useToast } from '@/hooks/useToast';
import { Button } from '@/components/ui/Button';

export function PedidosHub() {
  const { toast } = useToast();
  const [view, setView] = useState<'kanban' | 'lista'>('kanban');
  const [gerando, setGerando] = useState(false);

  const handleGerarLote = async () => {
    try {
      setGerando(true);
      const res = await api.post('/logistica/gerar-etiquetas-lote', {});
      
      toast({
        title: 'Sucesso!',
        description: `${res.data.count} etiquetas geradas. Abrindo arquivo...`,
      });

      if (res.data.url) {
        window.open(res.data.url, '_blank');
      }
    } catch (error: any) {
      toast({
        title: 'Aviso',
        description: error.response?.data?.error || 'Nenhum pedido pendente de etiqueta.',
        variant: 'default'
      });
    } finally {
      setGerando(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Pedidos</h1>
          <p className="text-gray-500">Gerencie e avance os pedidos na esteira de produção</p>
        </div>
        <div className="flex gap-1 p-1 bg-gray-100 rounded-xl">
          <button
            onClick={() => setView('kanban')}
            className={cn(
              'flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
              view === 'kanban' ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:text-gray-700'
            )}
          >
            <LayoutGrid className="w-4 h-4" />
            Pipeline
          </button>
          <button
            onClick={() => setView('lista')}
            className={cn(
              'flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
              view === 'lista' ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:text-gray-700'
            )}
          >
            <List className="w-4 h-4" />
            Lista
          </button>
        </div>

        <Button 
          variant="outline" 
          onClick={handleGerarLote} 
          disabled={gerando}
          className="ml-4 border-emerald-200 text-emerald-700 hover:bg-emerald-50"
          leftIcon={gerando ? <Loader2 className="w-4 h-4 animate-spin" /> : <Truck className="w-4 h-4" />}
        >
          {gerando ? 'Processando ME...' : 'Gerar Etiquetas (Lote)'}
        </Button>
      </div>

      {view === 'kanban' ? <KanbanPedidos /> : <ListaPedidos />}
    </div>
  );
}
